import { getRoleDashboardPath, getRoleToken, getStoredRole } from './authSession';
import { getUserAccessToken, getUserSession } from './userSession';

const MARKETING_ROLES = new Set(['user', 'advertiser']);

const ROLE_LABELS = {
    user: 'Screen Host',
    advertiser: 'Advertiser',
};

/**
 * Returns the active screen-host or advertiser session for marketing pages.
 * Screen hosts are stored under the "user" role; advertisers under "advertiser".
 */
export const getMarketingAuthState = () => {
    let role = getStoredRole();

    if (!role) {
        const session = getUserSession();
        const token = session?.token || getUserAccessToken();
        if (token) {
            role = 'user';
        }
    }

    if (!role || !MARKETING_ROLES.has(role)) {
        return { isSignedIn: false, role: null, dashboardPath: null, roleLabel: null };
    }

    const token = getRoleToken(role) || (role === 'user' ? getUserAccessToken() : null);
    if (!token) {
        return { isSignedIn: false, role: null, dashboardPath: null, roleLabel: null };
    }

    return {
        isSignedIn: true,
        role,
        dashboardPath: getRoleDashboardPath(role),
        roleLabel: ROLE_LABELS[role],
    };
};
